import { makeStyles } from '@material-ui/core/styles';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { color } from '../../../app/theme';
import { GATriggerType, NodeType, UrlFilterType } from '../../../app/types';
import {
  setDataByNodeId,
  setNodeById,
  setSelectedNode,
} from '../../../features/mainSlice';
import Dropdown from '../../shared/Dropdown';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    title: {
      fontSize: '15px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      marginBottom: 12,
    },
  },
  {
    name: 'Rule',
  },
);

const Rule = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedNode, data: maData } = useSelector(state => state.ma);
  const { nodes, edges } = maData || {};
  const { data } = selectedNode || {};
  const { type } = data || {};

  const targetNodeId = useMemo(
    () => (edges.find(e => e?.source === selectedNode?.id) || {})?.target,
    [selectedNode],
  );

  const targetNode = useMemo(
    () => nodes.find(n => n?.id === targetNodeId),
    [targetNodeId],
  );

  const clearTargetAutoTrackProduct = async () => {
    if (targetNode?.type === NodeType?.MESSAGE) {
      await dispatch(
        setDataByNodeId(targetNode?.id, {
          ...targetNode?.data,
          messages: targetNode?.data?.messages?.map(msg => {
            return {
              ...msg,
              data: {
                ...msg?.data,
                autoTrackProduct: undefined,
              },
            };
          }),
        }),
      );
    }
  };

  const onChange = value => {
    let newNode = {};

    switch (value) {
      case GATriggerType.GAVIEW:
        newNode = {
          ...selectedNode,
          data: {
            type: value,
            logicType: 'and',
            conditions: [
              {
                urlType: UrlFilterType.EQ,
                url: '',
                pageViewTimes: 1,
                staySec: null,
              },
            ],
          },
        };
        break;
      case GATriggerType.GAREMOVEFROMCART:
      case GATriggerType.GAADDTOCART:
      case GATriggerType.GAPURCHASE:
        newNode = { ...selectedNode, data: { type: value } };
        break;
      default:
        break;
    }

    if (value !== GATriggerType.GAADDTOCART) {
      clearTargetAutoTrackProduct();
    }

    dispatch(setSelectedNode(newNode));
    dispatch(setNodeById(newNode));
  };

  const menuItems = [
    {
      text: t(`GAConditionNode.trigger.${GATriggerType.GAVIEW}`),
      value: GATriggerType.GAVIEW,
    },
    {
      text: t(`GAConditionNode.trigger.${GATriggerType.GAREMOVEFROMCART}`),
      value: GATriggerType.GAREMOVEFROMCART,
    },
    {
      text: t(`GAConditionNode.trigger.${GATriggerType.GAADDTOCART}`),
      value: GATriggerType.GAADDTOCART,
    },
    {
      text: t(`GAConditionNode.trigger.${GATriggerType.GAPURCHASE}`),
      value: GATriggerType.GAPURCHASE,
    },
  ];

  return (
    <div className={classes.root}>
      <div className={classes.title}>{t('add-GAConditions')}</div>
      <Dropdown
        className={classes.dropdown}
        menuItems={menuItems}
        value={type}
        onChange={onChange}
      />
    </div>
  );
};

export default Rule;
